module.exports = __webpack_public_path__ + "media/images/empty/like-55cfa4d0134ccab2a05ab93ce3b840e5.svg";